<template functional>
    <div
        class="EmptyList"
        :class="[ data.class, data.staticClass ]"
        :style="data.style"
    >
        <slot name="header" />
        <WIcon
            v-if="props.icon"
            :icon="props.icon"
            :color="props.iconColor"
            :size="props.iconSize"
        />
        <WText
            v-if="props.title"
            size="20"
            weight="semi"
            :color="props.color"
        >
            {{ props.title }}
        </WText>
        <WText
            v-if="props.text"
            :color="props.color"
            size="14"
            class="Text"
        >
            {{ props.text }}
        </WText>
        <slot name="footer" />
    </div>
</template>
<script>
import VueTypes from 'vue-types'

export default {
    name: 'EmptyList',
    props: {
        title: VueTypes.string,
        text: VueTypes.string,
        icon: VueTypes.string,
        iconColor: VueTypes.string,
        iconSize: VueTypes.number.def(40),
        color: VueTypes.string,
    },
}
</script>
<style scoped lang="scss">
.EmptyList {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    flex-grow: 1;
    padding: 15px;

	.WText {
		&.Text {
			margin-bottom: 0px;
		}
	}
}
</style>
